<template>
  <transition leave-active-class="duration-200">
    <div
      @keydown="$refs.progressbar.userKeyDown()"
      @keyup="$refs.progressbar.userKeyUp()"
      @click="calculate_progress"
      v-if="showing === true && loadingData === false"
      class="z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex items-center justify-center"
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div class="fixed inset-0 transition-opacity" @click="closePopup()">
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- BEGIN Content modal -->
      <div
        class="bg-white rounded-lg py-6 overflow-scroll max-h-9/10 shadow-xl transform transition-all lg:w-4/6 sm:w-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
        @scroll="$refs.progressbar.reduceProgressBar($event)"
      >
        <div
          class="cursor-pointer absolute right-5 top-20 rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
          @click="closePopup()"
        >
          <icon name="close" />
        </div>
        <div class="sticky top-0 z-10">
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 translate-y-0 sm:scale-100"
            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              v-if="messageHeader.type !== '' && messageHeader.msg !== ''"
              class="absolute text-center py-5 mt-10 w-6/12 left-3/12 right-3/12 text-base flex items-center justify-center"
              :class="{
                'bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600':
                  messageHeader === 'saveIsSuccess' ||
                  messageHeader === 'transferIsSuccess',
                'bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600':
                  messageHeader === 'error' ||
                  messageHeader === 'noName' ||
                  messageHeader === 'lastModule' ||
                  messageHeader === 'evaluationInProgress',
                'bg-amber-100 border-2 border-amber-600 border-opacity-25 text-amber-600':
                  messageHeader === 'noSave',
              }"
            >
              <div>
                <div class="flex items-center justify-center">
                  <icon
                    v-if="
                      messageHeader === 'saveIsSuccess' ||
                      messageHeader === 'transferIsSuccess'
                    "
                    class="inline-block mr-2"
                    name="checkmark-circle-2"
                  />
                  <icon
                    v-else-if="
                      messageHeader === 'error' ||
                      messageHeader === 'noName' ||
                      messageHeader === 'lastModule'
                    "
                    class="inline-block mr-2"
                    name="alert-triangle"
                  />
                  <icon
                    v-else-if="messageHeader === 'noSave'"
                    class="inline-block mr-2"
                    name="alert-triangle"
                  />

                  <div v-if="messageHeader === 'saveIsSuccess'">
                    Vos données ont été enregistrées.
                  </div>
                  <div v-if="messageHeader === 'transferIsSuccess'">
                    Le référentiel de formation à bien été transférée.
                  </div>
                  <div v-if="messageHeader === 'evaluationInProgress'">
                    Vous ne pouvez pas modifier un référentiel de formation
                    utilisée par une évaluation.
                  </div>
                  <div v-if="messageHeader === 'error'">
                    Erreur d'enregistrement des données.
                  </div>
                  <div v-if="messageHeader === 'lastModule'">
                    Vous ne pouvez pas supprimer le dernier domaine.
                  </div>
                  <div v-if="messageHeader === 'noName'">
                    Veuillez remplir le champ "nom de la formation"<br />
                    pour enregistrer le référentiel.
                  </div>
                  <div v-if="messageHeader === 'noSave'">
                    Vous avez des modifications non sauvegardées.<br />
                  </div>
                </div>

                <div v-if="messageHeader === 'noSave'" class="mt-5">
                  <button
                    class="border-amber-600 border-opacity-25 text-amber-600 bg-amber-100 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2 mr-4"
                    @click="cancel_nosave()"
                  >
                    ANNULER
                  </button>

                  <button
                    class="bg-amber-600 text-amber-100 border-amber-100 border-opacity-25 border-2 rounded-md transform hover:scale-110 duration-300 text-base p-2"
                    @click="closeWithoutSaving()"
                  >
                    QUITTER
                  </button>
                </div>
              </div>
            </div>
          </transition>
          <!-- Save button -->
          <div
            v-if="
              editable &&
              $can(
                constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
              )
            "
            class="absolute right-15 mt-13 flex items-center justify-center"
          >
            <div
              v-if="saving"
              class="w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
            >
              <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
            </div>
            <div
              v-else
              class="rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14"
              @click="save_datas"
            >
              <icon class="h-6 w-6 ml-4 mt-1/4" name="save" />
            </div>
          </div>

          <div
            v-else-if="
              !editable &&
              $can(constants.PERMISSION_REFERENTIEL_FORMATION_COMMUNE_EDITER)
            "
            class="absolute right-15 mt-13 flex items-center justify-center"
          >
            <div
              v-if="saving"
              class="w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
            >
              <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
            </div>
            <div
              v-else
              class="rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white w-14 h-14"
              @click="save_datas"
            >
              <icon class="h-6 w-6 ml-4 mt-1/4" name="save" />
            </div>
          </div>
        </div>

        <!-- Progress bar -->
        <progress-bar
          v-if="editable"
          ref="progressbar"
          :in-popup="true"
          class="mx-6"
        />
        <!-- End Progress bar -->

        <!-- Content form -->
        <div class="grid grid-cols-12 my-5 md:my-15">
          <h3
            v-if="form.nom_du_poste === '' || form.nom_du_poste == null"
            class="col-span-full"
          >
            Nouvelle formation
          </h3>
          <h3 v-else class="col-span-full">
            {{ form.nom_du_poste }}
          </h3>

          <!-- BEGIN informations de base -->
          <h4 class="col-span-full text-indigo-600 my-10">
            Informations de base
          </h4>

          <div class="mx-5 md:mx-15 col-span-full grid grid-cols-12 gap-4">
            <input-text
              :class="'lg:col-span-4'"
              :disabled="!editable"
              :necessary="true"
              :value="form.nom_du_poste"
              libelle="Nom de la formation"
              name="nom_du_poste"
              @input="
                (newValue) => {
                  form.nom_du_poste = newValue;
                }
              "
            />

            <input-select
              :datas="categories"
              :disabled="!editable"
              :necessary="true"
              :value="form.sector"
              class="lg:col-span-4"
              libelle="Secteur d'activité"
              name="sector"
              @input="
                (newValue) => {
                  form.sector = newValue;
                  setIndex(newValue);
                }
              "
            />

            <input-select
              :datas="listFamilies"
              :disabled="!editable"
              :necessary="true"
              :value="form.family"
              class="lg:col-span-4"
              libelle="Famille professionnelle"
              name="family"
              @input="
                (newValue) => {
                  form.family = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.evolution"
              class="lg:col-span-4"
              libelle="Présentation de l’évolution du Titre Professionnel"
              name="evolution"
              @input="
                (newValue) => {
                  form.evolution = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.contexte_exam"
              class="lg:col-span-4"
              libelle="Contexte de l’examen du Titre Professionnel"
              name="contexte_exam"
              @input="
                (newValue) => {
                  form.contexte_exam = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.def_emploi"
              class="lg:col-span-4"
              libelle="Définition de l’emploi type"
              name="def_emploi"
              @input="
                (newValue) => {
                  form.def_emploi = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.conditions_exercice"
              class="lg:col-span-4"
              libelle="Conditions d’exercice"
              name="conditions_exercice"
              @input="
                (newValue) => {
                  form.conditions_exercice = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.secteurs_accessibles"
              class="lg:col-span-4"
              libelle="Secteurs d’activité accessibles par le détenteur du titre"
              name="secteurs_accessibles"
              @input="
                (newValue) => {
                  form.secteurs_accessibles = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.type_emplois_accessibles"
              class="lg:col-span-4"
              libelle="Types d’emplois accessibles par le détenteur du titre"
              name="type_emplois_accessibles"
              @input="
                (newValue) => {
                  form.type_emplois_accessibles = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.reglementation_activite"
              class="lg:col-span-4"
              libelle="Réglementation d’activités (le cas échéant)"
              name="reglementation_activite"
              @input="
                (newValue) => {
                  form.reglementation_activite = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.certifications_equivalentes"
              class="lg:col-span-4"
              libelle="Equivalences avec d’autres certifications (le cas échéant)"
              name="certifications_equivalentes"
              @input="
                (newValue) => {
                  form.certifications_equivalentes = newValue;
                }
              "
            />

            <input-text-area
              :disabled="!editable"
              :necessary="true"
              :size="5"
              :value="form.competences_transversales"
              class="lg:col-span-4"
              libelle="Compétences transversales de l’emploi (le cas échéant)"
              name="competences_transversales"
              @input="
                (newValue) => {
                  form.competences_transversales = newValue;
                }
              "
            />

            <input-text
              :disabled="!editable"
              :necessary="true"
              :value="form.niveau"
              class="lg:col-span-4"
              libelle="Niveau"
              name="niveau"
              @input="
                (newValue) => {
                  form.niveau = newValue;
                }
              "
            />

            <input-text
              :disabled="!editable"
              :necessary="true"
              :value="form.convention"
              class="lg:col-span-4"
              libelle="Convention"
              name="convention"
              @input="
                (newValue) => {
                  form.convention = newValue;
                }
              "
            />

            <input-text
              :disabled="!editable"
              :necessary="true"
              :value="form.nsf"
              class="lg:col-span-4"
              libelle="Code(s) NSF"
              name="nsf"
              @input="
                (newValue) => {
                  form.nsf = newValue;
                }
              "
            />

            <!-- BEGIN Referentiels correspondants -->
            <h4 class="text-indigo-600 col-span-full mt-10 mb-5">
              Référentiels correspondants
            </h4>

            <input-text
              :disabled="!editable"
              :necessary="false"
              :value="form.rome"
              class="lg:col-span-3"
              libelle="ROME"
              name="rome"
              @input="
                (newValue) => {
                  form.rome = newValue;
                }
              "
            />
            <input-text
              :disabled="!editable"
              :necessary="false"
              :value="form.rsfp"
              class="lg:col-span-3"
              libelle="RSFP"
              name="rsfp"
              @input="
                (newValue) => {
                  form.rsfp = newValue;
                }
              "
            />
            <input-text
              :disabled="!editable"
              :necessary="false"
              :value="form.rncp"
              class="lg:col-span-3"
              libelle="Diplômes et titre (RNCP)"
              name="rncp"
              @input="
                (newValue) => {
                  form.rncp = newValue;
                }
              "
            />
            <input-text
              :disabled="!editable"
              :necessary="false"
              :value="form.convention_collective"
              class="lg:col-span-3"
              libelle="Conventions collectives"
              name="convention_collective"
              @input="
                (newValue) => {
                  form.convention_collective = newValue;
                }
              "
            />
            <!-- END Referentiels correspondants -->
          </div>
          <!-- END informations de base -->

          <!-- BEGIN Modules content -->
          <div class="col-span-full mt-10">
            <!-- BEGIN Liste modules -->
            <div class="my-10">
              <div
                class="w-full flex flex-col justify-center items-center mb-10 mx-5 md:mx-15"
              >
                <div class="max-w-8/10 flex flex-col items-end">
                  <div
                    class="flex flex-row justify-center items-center cursor-pointer w-full"
                    @click="displayModulelist"
                    @click.stop
                  >
                    <div class="flex flex-row items-end justify-center ml-2">
                      <h4 class="text-indigo-600 text-center select-none">
                        {{
                          'Domaine ' +
                          (currentModule + 1) +
                          ' : ' +
                          (form.modules[currentModule].module_name === ''
                            ? 'Nom du domaine'
                            : form.modules[currentModule].module_name)
                        }}
                      </h4>
                    </div>
                    <div
                      class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
                    >
                      <icon class="h-4 w-4" name="chevron-down" />
                    </div>
                  </div>
                  <div class="activitylist relative w-60 h-0">
                    <div
                      v-if="showList"
                      v-click-outside="displayModulelist"
                      class="absolute w-full flex z-20 rounded-md bg-white shadow-md shadow-gray-600 text-sm right-0"
                    >
                      <div class="mx-5 my-3">
                        <div class="text-left">
                          <div
                            v-for="(module, i) in form.modules"
                            :key="i"
                            class="first:pt-2 py-1"
                          >
                            <p
                              class="text-gray-600 hover:text-gray-900 cursor-pointer"
                              @click="currentModule = i"
                            >
                              <span>{{
                                'Module ' + (i + 1) + ' : ' + module.module_name
                              }}</span>
                            </p>
                          </div>
                          <div
                            v-if="editable"
                            class="border-t pt-2 mt-5 text-gray-600 hover:text-gray-900 cursor-pointer"
                            @click="addModule"
                          >
                            <span>Ajouter un domaine</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="editable"
                class="flex items-center mb-10 mx-5 md:mx-15"
              >
                <div
                  class="flex flex-row justify-start items-center w-max cursor-pointer"
                  @click="deleteModule"
                >
                  <div
                    class="cursor-pointer relative rounded-full px-2 py-2 bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25 transition ease-in-out duration-500 hover:text-white hover:bg-pink-600"
                  >
                    <icon name="close" />
                  </div>
                  <h3
                    class="flex ml-3 text-left text-lg text-gray-600 hover:font-semibold"
                  >
                    Supprimer le domaine
                  </h3>
                </div>
                <div class="flex-grow" />
                <div class="flex-none w-max relative">
                  <action-button
                    bg-color="bg-orange-300"
                    bg-color-square="bg-orange-100"
                    border-color="border-transparent"
                    icon="swap"
                    icon-color="text-orange-600"
                    libelle="Intervertir les modules"
                    text-color="text-gray-900"
                    @clickAction="displayInvertModuleMenu"
                  />
                  <div
                    v-if="isInvertModuleMenuDisplayed"
                    v-click-outside="hideInvertModuleMenu"
                    class="z-20 absolute right-0 top-13 text-sm w-max max-w-md bg-white rounded-md shadow-md shadow-gray-600 px-6 py-5 cursor-default flex flex-col space-y-1"
                  >
                    <draggable
                      v-model="form.modules"
                      v-bind="dragOptions"
                      @end="drag = false"
                      @start="drag = true"
                    >
                      <transition-group
                        enter-active-class="ease-in duration-1000"
                        enter-class="bg-indigo-300 border-0 rounded-xl"
                        enter-to-class="bg-none border-0 rounded-xl"
                        leave-active-class="linear duration-1000"
                        leave-class="h-20 opacity-100"
                        leave-to-class="h-0 opacity-0"
                        tag="div"
                      >
                        <div
                          v-for="(module, iMod) in form.modules"
                          :key="'A' + iMod"
                        >
                          <div
                            class="grid grid-cols-12 cursor-pointer items-center gap-x-2"
                          >
                            <icon
                              class="text-indigo-600 col-span-1"
                              name="move"
                            />
                            <p
                              class="text-gray-600 hover:text-gray-900 col-span-11"
                            >
                              {{ module.module_name }}
                            </p>
                          </div>
                          <hr
                            v-if="iMod < form.modules.length - 1"
                            class="my-2.5 border-indigo-300"
                          />
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </div>

              <div
                v-for="(module, index) in form.modules"
                :key="'modulegeneral' + index"
              >
                <div v-show="currentModule === index">
                  <div class="grid grid-cols-12 gap-4 mx-5 md:mx-15">
                    <input-text
                      :disabled="!editable"
                      :necessary="true"
                      :value="form.modules[index].module_name"
                      class="lg:col-span-6"
                      libelle="Nom du domaine"
                      name="module_name"
                      @input="
                        (newValue) => {
                          $set(form.modules[index], 'module_name', newValue);
                        }
                      "
                    />
                    <input-select
                      :datas="tempsConsacreValues"
                      :disabled="!editable"
                      :name="'temps_consacre'"
                      :necessary="true"
                      :value="form.modules[index].module_time"
                      class="lg:col-span-6"
                      libelle="Temps consacré"
                      @input="
                        (newValue) => {
                          $set(
                            form.modules[index].module_time,
                            'temps_consacre',
                            newValue
                          );
                        }
                      "
                    />

                    <input-text-area
                      :disabled="!editable"
                      :necessary="true"
                      :size="5"
                      :value="form.modules[index].module_def"
                      class="lg:col-span-6"
                      libelle="Définition du domaine"
                      name="definition"
                      @input="
                        (newValue) => {
                          $set(form.modules[index], 'module_def', newValue);
                        }
                      "
                    />
                    <input-text-area
                      :disabled="!editable"
                      :necessary="true"
                      :size="5"
                      :value="form.modules[index].module_reglementation"
                      class="lg:col-span-6"
                      libelle="Règlementation"
                      name="reglementation"
                      @input="
                        (newValue) => {
                          $set(
                            form.modules[index],
                            'module_reglementation',
                            newValue
                          );
                        }
                      "
                    />
                  </div>

                  <div class="mb-5 mt-15">
                    <h5
                      class="text-left uppercase text-base text-indigo-600 mb-5 mx-5 md:mx-15"
                    >
                      Competences
                    </h5>

                    <add-button
                      libelle="Ajouter une compétence"
                      :disabled="!editable"
                      @add="
                        addCompetence(
                          form.modules[index].module_competences,
                          'competence',
                          index
                        )
                      "
                      class="mx-5 md:mx-15"
                    />
                    <div
                      v-if="form.modules[index].module_competences.length > 0"
                      class="grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32 text-lg"
                    >
                      <span
                        class="col-start-3 col-span-4 justify-items-start text-base text-gray-500"
                        >Compétences</span
                      >
                      <span
                        class="col-span-4 justify-items-start text-base text-gray-500"
                        >Description</span
                      >
                      <span
                        class="col-span-2 justify-items-start text-base text-gray-500"
                        >Nb. de critères</span
                      >
                    </div>

                    <draggable
                      v-model="form.modules[currentModule].module_competences"
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptionsComp"
                      :style="{
                        'cursor:grab;': $can(
                          constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
                        ),
                      }"
                    >
                      <transition-group
                        enter-active-class="ease-in duration-1000"
                        enter-class="bg-indigo-300 border-0 rounded-xl"
                        enter-to-class="bg-none border-0 rounded-xl"
                        leave-active-class="linear duration-1000"
                        leave-class="h-20 opacity-100"
                        leave-to-class="h-0 opacity-0"
                        tag="div"
                      >
                        <div
                          v-for="(competence, compindex) in form.modules[index]
                            .module_competences"
                          :key="'competence' + compindex"
                          class="odd:bg-indigo-200 odd:bg-opacity-50"
                        >
                          <div
                            class="grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32"
                            :class="{
                              'bg-indigo-200 border-l-2 border-indigo-600':
                                itemDisplayed === compindex,
                            }"
                            @click="displayItem(compindex)"
                            :id="'item-competence-' + index + '-' + compindex"
                          >
                            <div
                              class="col-span-1 items-center justify-self-end"
                            >
                              <icon class="text-indigo-600" name="move" />
                            </div>
                            <div
                              class="col-span-1 items-center justify-self-center"
                              @click="displayItem(compindex)"
                            >
                              <icon
                                class="text-pink-600 transform transition-transform ease-in-out duration-300"
                                :class="{
                                  'rotate-90': itemDisplayed === compindex,
                                }"
                                name="chevron-right"
                              />
                            </div>
                            <span
                              class="col-span-4 justify-items-start text-base text-gray-900"
                              >{{ competence.name }}</span
                            >
                            <span
                              class="col-span-4 justify-items-start text-sm text-gray-900 italic line-clamp-4"
                              >{{ competence.description }}</span
                            >
                            <span
                              class="col-span-2 justify-items-start text-base text-gray-900"
                              >{{ competence.criterions.length }}</span
                            >
                          </div>

                          <transition
                            enter-active-class="ease-out duration-300"
                            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                            leave-active-class="ease-in duration-200"
                            leave-class="opacity-100 translate-y-0 sm:scale-100"
                            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          >
                            <div
                              v-show="itemDisplayed === compindex"
                              class="min-h-24 bg-white"
                            >
                              <div
                                class="grid grid-cols-2 gap-x-4 mx-5 md:mx-15 pt-10"
                              >
                                <input-text
                                  v-if="editable"
                                  :disabled="!editable"
                                  :necessary="true"
                                  :value="competence.name"
                                  libelle="Nom de la compétence"
                                  name="competence_name"
                                  @input="
                                    (newValue) => {
                                      competence.name = newValue;
                                    }
                                  "
                                  class="lg:col-span-1"
                                />

                                <input-text
                                  v-if="editable"
                                  :disabled="!editable"
                                  :necessary="true"
                                  :value="competence.description"
                                  libelle="Description"
                                  name="competence_description"
                                  @input="
                                    (newValue) => {
                                      competence.description = newValue;
                                    }
                                  "
                                  class="lg:col-span-1"
                                />
                              </div>

                              <div class="mx-5 md:mx-15">
                                <h3
                                  class="uppercase text-indigo-600 text-base text-left my-10"
                                >
                                  Critères et indicateurs d'acceptation
                                </h3>
                                <add-button
                                  libelle="Ajouter un critère"
                                  :disabled="!editable"
                                  class="w-max mb-5"
                                  @add="
                                    addCritere(
                                      form.modules[index].module_competences[
                                        compindex
                                      ].criterions
                                    )
                                  "
                                />
                              </div>

                              <div class="mx-5 md:mx-15">
                                <draggable
                                  v-model="competence.criterions"
                                  @start="drag = true"
                                  @end="drag = false"
                                  v-bind="dragOptionsCrit"
                                  :style="{
                                    'cursor:grab;': $can(
                                      constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
                                    ),
                                  }"
                                >
                                  <transition-group
                                    enter-active-class="ease-in duration-1000"
                                    enter-class="bg-indigo-300 border-0 rounded-xl"
                                    enter-to-class="bg-none border-0 rounded-xl"
                                    leave-active-class="linear duration-1000"
                                    leave-class="h-20 opacity-100"
                                    leave-to-class="h-0 opacity-0"
                                    tag="div"
                                  >
                                    <div
                                      v-for="(
                                        criterion, jndex
                                      ) in competence.criterions"
                                      :key="'crit' + compindex + jndex"
                                      class="mt-5 last:mb-5"
                                    >
                                      <DoubleInputTextWithAction
                                        libelle-left="Critère"
                                        libelle-right="Indicateur"
                                        :necessary="true"
                                        :value-left="criterion.name"
                                        :value-right="criterion.indicateur"
                                        :disabled="!editable"
                                        :is-grabable="true"
                                        :style="'cursor:grab'"
                                        @inputLeft="
                                          (newValue) => {
                                            criterion.name = newValue;
                                          }
                                        "
                                        @inputRight="
                                          (newValue) => {
                                            criterion.indicateur = newValue;
                                          }
                                        "
                                        @duplicate="
                                          form.modules[
                                            index
                                          ].module_competences[compindex].push(
                                            criterion
                                          )
                                        "
                                        @delete="
                                          deleteFromModule(
                                            form.modules[index]
                                              .module_competences[compindex]
                                              .criterions,
                                            jndex
                                          )
                                        "
                                        @switchEditable="
                                          (state) => {
                                            changeDraggableCriterionState(
                                              'competence',
                                              compindex,
                                              jndex,
                                              state
                                            );
                                          }
                                        "
                                        :draggable="true"
                                        :prefix-text-left="jndex + 1 + '. '"
                                        :prefix-text-right="jndex + 1 + '. '"
                                        :ref="
                                          'comp' +
                                          compindex +
                                          'criterion' +
                                          jndex
                                        "
                                      />
                                    </div>
                                  </transition-group>
                                </draggable>
                              </div>
                              <div class="mx-5 md:mx-15 mt-10">
                                <div
                                  v-if="editable"
                                  class="w-max"
                                  @click="
                                    deleteFromModule(
                                      form.modules[index].module_competences,
                                      compindex
                                    )
                                  "
                                >
                                  <delete-button
                                    libelle="Supprimer la compétence"
                                  />
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>

                  <div class="mb-5 mt-15">
                    <h5
                      class="text-left uppercase text-base text-indigo-600 mb-5 mx-5 md:mx-15"
                    >
                      Competences transversales
                    </h5>
                    <add-button
                      libelle="Ajouter une compétence transversale"
                      :disabled="!editable"
                      @add="
                        addCompetence(
                          form.modules[index].module_competences_transversales,
                          'competence-transversale',
                          index
                        )
                      "
                      class="mx-5 md:mx-15"
                    />
                    <div
                      class="grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32 text-lg"
                      v-if="
                        form.modules[index].module_competences_transversales
                          .length > 0
                      "
                    >
                      <span
                        class="col-start-3 col-span-4 justify-items-start text-base text-gray-500"
                        >Compétences</span
                      >
                      <span
                        class="col-span-4 justify-items-start text-base text-gray-500"
                        >Description</span
                      >
                      <span
                        class="col-span-2 justify-items-start text-base text-gray-500"
                        >Nb. de critères</span
                      >
                    </div>

                    <draggable
                      v-model="
                        form.modules[index].module_competences_transversales
                      "
                      @start="drag = true"
                      @end="drag = false"
                      v-bind="dragOptionsCompTr"
                      :style="{
                        'cursor:grab;': $can(
                          constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
                        ),
                      }"
                    >
                      <transition-group
                        enter-active-class="ease-in duration-1000"
                        enter-class="bg-indigo-300 border-0 rounded-xl"
                        enter-to-class="bg-none border-0 rounded-xl"
                        leave-active-class="linear duration-1000"
                        leave-class="h-20 opacity-100"
                        leave-to-class="h-0 opacity-0"
                        tag="div"
                      >
                        <div
                          v-for="(competence_transversales, lndex) in form
                            .modules[index].module_competences_transversales"
                          :key="'competenceTR' + lndex"
                          class="odd:bg-indigo-200 odd:bg-opacity-50"
                        >
                          <div
                            class="grid grid-cols-12 items-center gap-4 h-16 lg:h-24 2xl:h-32"
                            :class="{
                              'bg-indigo-200 border-l-2 border-indigo-600':
                                compTrDisplayed === lndex,
                            }"
                            @click="displayCompTr(lndex)"
                            :id="
                              'item-competence-transversale-' +
                              index +
                              '-' +
                              lndex
                            "
                          >
                            <div class="col-span-1 justify-self-end">
                              <icon class="text-indigo-600" name="move" />
                            </div>
                            <div class="col-span-1 justify-self-center">
                              <icon
                                class="text-pink-600 transform transition-transform ease-in-out duration-300"
                                :class="{
                                  'rotate-90': compTrDisplayed === lndex,
                                }"
                                name="chevron-right"
                              />
                            </div>
                            <span
                              class="col-span-4 justify-items-start text-base text-gray-900"
                              >{{ competence_transversales.name }}</span
                            >
                            <span
                              class="col-span-4 justify-items-start text-sm text-gray-900 italic line-clamp-4"
                              >{{ competence_transversales.description }}</span
                            >
                            <span
                              class="col-span-2 justify-items-start text-base text-gray-900"
                              >{{
                                competence_transversales.criterions.length
                              }}</span
                            >
                          </div>

                          <transition
                            enter-active-class="ease-out duration-300"
                            enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                            leave-active-class="ease-in duration-200"
                            leave-class="opacity-100 translate-y-0 sm:scale-100"
                            leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                          >
                            <div
                              v-if="compTrDisplayed === lndex"
                              class="min-h-24 bg-white"
                            >
                              <div
                                class="grid grid-cols-2 gap-x-4 mx-5 md:mx-15 pt-10"
                              >
                                <input-text
                                  v-if="editable"
                                  :disabled="!editable"
                                  :necessary="false"
                                  :value="competence_transversales.name"
                                  libelle="Nom de la compétence"
                                  name="competence_name"
                                  @input="
                                    (newValue) => {
                                      competence_transversales.name = newValue;
                                    }
                                  "
                                  class="lg:col-span-1"
                                />

                                <input-text
                                  v-if="editable"
                                  :disabled="!editable"
                                  :necessary="false"
                                  :value="competence_transversales.description"
                                  libelle="Description"
                                  name="competence_description"
                                  @input="
                                    (newValue) => {
                                      competence_transversales.description =
                                        newValue;
                                    }
                                  "
                                  class="lg:col-span-1"
                                />
                              </div>
                              <div class="mx-5 md:mx-15">
                                <h3
                                  class="uppercase text-indigo-600 text-base text-left my-10"
                                >
                                  Critères et indicateurs d'acceptation
                                </h3>
                                <add-button
                                  libelle="Ajouter un critère"
                                  :disabled="!editable"
                                  class="w-max mb-5"
                                  @add="
                                    addCritere(
                                      form.modules[index]
                                        .module_competences_transversales[lndex]
                                        .criterions
                                    )
                                  "
                                />
                              </div>

                              <div class="mx-5 md:mx-15">
                                <draggable
                                  v-model="competence_transversales.criterions"
                                  @start="drag = true"
                                  @end="drag = false"
                                  v-bind="dragOptionsCritTr"
                                  :style="{
                                    'cursor:grab;': $can(
                                      constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
                                    ),
                                  }"
                                >
                                  <transition-group
                                    enter-active-class="ease-in duration-1000"
                                    enter-class="bg-indigo-300 border-0 rounded-xl"
                                    enter-to-class="bg-none border-0 rounded-xl"
                                    leave-active-class="linear duration-1000"
                                    leave-class="h-20 opacity-100"
                                    leave-to-class="h-0 opacity-0"
                                    tag="div"
                                  >
                                    <div
                                      v-for="(
                                        criterion_transversales, kndex
                                      ) in competence_transversales.criterions"
                                      :key="'critTR' + lndex + kndex"
                                      class="mt-5 last:mb-5"
                                    >
                                      <DoubleInputTextWithAction
                                        libelle-left="Critère"
                                        libelle-right="Indicateur"
                                        :necessary="false"
                                        :value-left="
                                          criterion_transversales.name
                                        "
                                        :value-right="
                                          criterion_transversales.indicateur
                                        "
                                        :disabled="!editable"
                                        :is-grabable="true"
                                        :style="'cursor:grab'"
                                        @inputLeft="
                                          (newValue) => {
                                            criterion_transversales.name =
                                              newValue;
                                          }
                                        "
                                        @inputRight="
                                          (newValue) => {
                                            criterion_transversales.indicateur =
                                              newValue;
                                          }
                                        "
                                        @duplicate="
                                          form.modules[
                                            index
                                          ].module_competences_transversales[
                                            lndex
                                          ].push(criterion_transversales)
                                        "
                                        @delete="
                                          deleteFromModule(
                                            form.modules[index]
                                              .module_competences_transversales[
                                              lndex
                                            ].criterion_transversales,
                                            kndex
                                          )
                                        "
                                        @switchEditable="
                                          (state) => {
                                            changeDraggableCriterionState(
                                              'competence_transversales',
                                              compindex,
                                              jndex,
                                              state
                                            );
                                          }
                                        "
                                        :draggable="true"
                                        :prefix-text-left="kndex + 1 + '. '"
                                        :prefix-text-right="kndex + 1 + '. '"
                                        :ref="
                                          'compTr' + lndex + 'criterion' + kndex
                                        "
                                      />
                                    </div>
                                  </transition-group>
                                </draggable>
                              </div>
                              <div class="mx-5 md:mx-15 mt-10">
                                <div
                                  v-if="editable"
                                  class="w-max col-start-2 mb-5"
                                  @click="
                                    deleteFromModule(
                                      form.modules[index]
                                        .module_competences_transversales,
                                      lndex
                                    )
                                  "
                                >
                                  <delete-button
                                    libelle="Supprimer la compétence"
                                  />
                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Liste modules -->
          </div>
          <!-- END Modules content -->
        </div>
        <!-- END Content form -->
      </div>
      <!-- END Content modal -->
    </div>
  </transition>
</template>

<script>
import Icon from '../components/Icon';
import ActionButton from '../components/ActionButton';
import AddButton from '../components/Inputs/AddButton';
import SaveButton from '../components/SaveButton';
import axios from '../api';
import { mapGetters, mapMutations } from 'vuex';
import store from '../store';
import InputText from '../components/Inputs/InputText';
import InputTextArea from '../components/Inputs/InputTextArea';
import MultipleSelect from '../components/Inputs/MultipleSelect';
import InputSelect from '../components/Inputs/InputSelect';
import ClickOutside from 'vue-click-outside';
import CloseButton from '../components/CloseButton';
import PageNotAllowed from '../components/PageNotAllowed';
import Popup from '../components/Popup';
import Illustration from '../components/Illustration';

import InputTextWithAction from '../components/Inputs/InputTextWithAction';
import draggable from 'vuedraggable';
import DoubleInputTextWithAction from './Inputs/DoubleInputTextWithAction';
import DeleteButton from './Inputs/DeleteButton';
import ProgressBar from './ProgressBar';

import Constants from './../constants';

export default {
  props: ['show', 'id', 'openedFromEditButton'],

  components: {
    DeleteButton,
    DoubleInputTextWithAction,
    Icon,
    ActionButton,
    SaveButton,
    InputText,
    InputTextArea,
    MultipleSelect,
    AddButton,
    InputSelect,
    CloseButton,
    PageNotAllowed,
    Popup,
    Illustration,
    draggable,
    InputTextWithAction,
    ProgressBar,
  },

  name: 'PopupReferentielFormation',

  data() {
    return {
      isMounted: false,
      loadingData: false,
      editable: true,
      smallBar: false,
      progress: 0,
      goal: 75,
      categories: [],
      showList: false,
      currentModule: 0,
      messageHeader: '',
      currentSector: '',
      saved: true,
      justLoaded: false,
      form: {},
      emptyForm: {
        nom_du_poste: '',
        sector: '',
        family: '',
        mission: '',
        objectif: '',
        contexte_organisationnel: '',
        passerelle_mobilité: '',
        formation_experience: '',
        modules: [
          {
            module_name: 'Nom du module',
            module_time: '',
            module_competences: [],
            module_competences_transversales: [],
            module_def: '',
            module_reglementation: '',
          },
        ],
        lecture: '',
        ecriture: '',
        calcul: '',
        informatique: '',
        communication: '',
        autres: '',
        rome: '',
        rsfp: '',
        rncp: '',
        convention_collective: '',
      },
      isInvertModuleMenuDisplayed: false,
      itemDisplayed: -1,
      compTrDisplayed: -1,

      listCritEditableByComp: {
        competence: [],
        competence_transversales: [],
      },

      constants: Constants,
      saving: false,
    };
  },

  created() {
    this.initializeComponent();
    this.calculate_progress();
  },

  mounted() {
    this.isMounted = true;
  },

  watch: {
    show() {
      if (this.showing) {
        this.initializeJob();
      } else {
        this.unload();
      }
    },
    form: {
      handler() {
        if (this.justLoaded) {
          this.saved = true;
          this.justLoaded = false;
        } else {
          this.saved = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
    }),
    showing: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('mutateShow', newValue);
      },
    },
    jobId: {
      get() {
        return this.id;
      },
      set(newValue) {
        this.$emit('mutateId', newValue);
      },
    },
    listFamilies() {
      if (this.currentSector === '' || this.currentSector === null) {
        this.allFamilies = [];
        for (let cat in this.categories) {
          for (let st in this.categories[cat].families) {
            this.allFamilies.push({
              value: this.categories[cat].families[st].value,
            });
          }
        }
        this.allFamilies.sort(function (a, b) {
          if (a.value > b.value) {
            return 1;
          } else if (a.value < b.value) {
            return -1;
          } else {
            return 0;
          }
        });
        return this.allFamilies;
      } else {
        return this.categories.filter((v) => v.value === this.currentSector)[0]
          .families;
      }
    },
    risk(val) {
      if (val === 'OUI') {
        return true;
      }
    },

    tempsConsacreValues() {
      // to fill hour and minutes select field
      return [
        { value: 'Majeur (+ de 50% du temps)' },
        { value: 'Secondaire (- de 50% du temps)' },
        { value: 'Mineur (- de 10% du temps)' },
      ];
    },

    dragOptions() {
      return {
        animation: 500,
        disabled:
          !this.editable ||
          !this.$can(
            Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
          ),
        ghostClass: 'bg-indigo-300',
      };
    },

    dragOptionsComp() {
      return {
        animation: 500,
        disabled:
          this.itemDisplayed > -1 ||
          !this.editable ||
          !this.$can(
            Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
          ),
        ghostClass: 'bg-indigo-300',
      };
    },

    dragOptionsCompTr() {
      return {
        animation: 500,
        disabled:
          this.compTrDisplayed > -1 ||
          !this.editable ||
          !this.$can(
            Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
          ),
        ghostClass: 'bg-indigo-300',
      };
    },

    dragOptionsCrit() {
      //drag is desactivated when at least one criterion is editable (even if this criterion belong to a competence with closed accordion)
      //So, take care of close criterion edition each time
      return {
        animation: 500,
        disabled:
          (this.itemDisplayed > -1 &&
            this.listCritEditableByComp['competence'].length > 0) ||
          !this.editable ||
          !this.$can(
            Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
          ),
        ghostClass: 'bg-indigo-300',
      };
    },

    dragOptionsCritTr() {
      //drag is desactivated when at least one criterion is editable (even if this criterion belong to a competence with closed accordion)
      //So, take care of close criterion edition each time
      return {
        animation: 500,
        disabled:
          (this.compTrDisplayed > -1 &&
            this.listCritEditableByComp['competence_transversales'].length >
              0) ||
          !this.editable ||
          !this.$can(
            Constants.PERMISSION_REFERENTIEL_FORMATION_PERSONNELLE_EDITER
          ),
        ghostClass: 'bg-indigo-300',
      };
    },
  },

  methods: {
    ...mapMutations({
      calculate_progress: 'neopass/calculate_progress',
    }),

    async load_sectors(context) {
      await axios
        .get('api/datatype/sectors')
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((error) => {
          console.log('ERRRR:: ', error.response);
        });
    },

    async save_datas() {
      if (
        this.form.nom_du_poste === '' ||
        this.form.nom_du_poste === null ||
        this.form.nom_du_poste === undefined
      ) {
        this.messageHeader = 'noName';
        setTimeout(() => {
          this.messageHeader = '';
        }, 3000);
      } else {
        this.saving = true;
        await axios
          .put('/api/sheets/' + this.jobId, { data: this.form })
          .then((response) => {
            this.messageHeader = 'saveIsSuccess';
            this.saved = true;
            setTimeout(() => {
              this.messageHeader = '';
            }, 3000);
            this.saving = false;
          })
          .catch((error) => {
            this.messageHeader = 'error';
            setTimeout(() => {
              this.messageHeader = '';
            }, 3000);
            this.saving = false;
            console.log('ERRRR:: ', error);
          });
      }
    },

    initializeComponent() {
      this.load_sectors();
      this.form = this.emptyForm;
    },

    setIndex(inputValue) {
      this.currentSector = inputValue;
    },

    initializeJob() {
      if (Number.isInteger(this.jobId)) {
        this.form = this.emptyForm;
        this.editable = this.openedFromEditButton;
        this.loadData();
      } else {
        throw new Error('Trying to open a desc without giving its ID');
      }
    },

    displayModulelist() {
      this.showList = !this.showList;
    },

    reduceProgressBar(event) {
      let el = event.target;
      this.smallBar = el.scrollTop > 10;
    },

    closePopup() {
      if (this.saved === false) {
        this.messageHeader = 'noSave';
      } else {
        this.currentModule = 0;
        this.messageHeader = '';
        this.saved = true;
        this.unload();
      }
    },

    closeWithoutSaving(e) {
      this.currentModule = 0;
      this.messageHeader = '';
      this.saved = true;
      this.unload();
    },

    cancel_nosave() {
      this.messageHeader = '';
    },

    deleteModule() {
      if (this.form.modules.length > 1) {
        this.form.modules.splice(this.currentModule, 1);
        this.currentModule = this.form.modules.length - 1;
      } else {
        this.messageHeader = 'lastModule';
        setTimeout(() => {
          this.messageHeader = '';
        }, 3000);
      }
    },

    async loadData() {
      await axios
        .get('/api/sheets/' + this.jobId)
        .then((response) => {
          this.form = response.data.data;
          this.justLoaded = true;
          this.loadingData = false;
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
        });
    },

    unload() {
      this.showing = false;
      this.jobId = null;
      this.form = this.emptyForm;
    },

    addModule() {
      let i = this.form.modules.length;
      this.form.modules.push({
        module_time: '',
        module_name: 'Nom du domaine type',
        module_def: null,
        module_reglementation: null,
        module_competences: [],
        module_competences_transversales: [],
      });
      this.currentModule = i;
    },

    /**
     * Add new competence, display content and scroll to it
     * @param Object what
     * @param String typeComp
     */
    async addCompetence(what, typeComp, moduleIndex) {
      await what.push({
        name: '',
        description: null,
        contexte: null,
        criterions: [],
      });
      this.itemDisplayed = what.length - 1;
      let pos = document.getElementById(
        'item-' + typeComp + '-' + moduleIndex + '-' + this.itemDisplayed
      );
      setTimeout(() => {
        pos.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    },

    addCritere(what) {
      what.push({ name: '', indicateur: '' });
    },

    deleteFromModule(where, what) {
      where.splice(what, 1);
    },

    displayInvertModuleMenu() {
      this.isInvertModuleMenuDisplayed = true;
    },

    hideInvertModuleMenu() {
      this.isInvertModuleMenuDisplayed = false;
    },

    displayItem(index) {
      this.itemDisplayed !== index
        ? (this.itemDisplayed = index)
        : (this.itemDisplayed = -1);
    },

    displayCompTr(index) {
      this.compTrDisplayed !== index
        ? (this.compTrDisplayed = index)
        : (this.compTrDisplayed = -1);
    },

    changeDraggableCriterionState(typeComp, numComp, numCrit, stateEditable) {
      if (
        (typeComp == 'competence' && this.itemDisplayed != numComp) ||
        (typeComp == 'competence_tranversales' &&
          this.compTrDisplayed != numComp)
      )
        return;

      if (stateEditable) {
        this.listCritEditableByComp[typeComp].push([numComp, numCrit]);
      }

      if (!stateEditable) {
        let index = this.listCritEditableByComp[typeComp].findIndex(
          (v) => v[0] == numComp && v[1] == numCrit
        );

        if (index !== -1) {
          this.listCritEditableByComp[typeComp].splice(index, 1);
        }
      }
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
